import { DEFAULT_WHEEL_DATA, POPUP_ENRICH_DATA_TRACKING_CODE } from '../../Constants'
import { closePopup, showPopup } from '../../Functions/sendTrackingEvents'
import { shouldShowPopup } from '../../Functions/shouldShowPopup'
import { fetchMiniGameData, validateEmail, submitMinigame } from '../../Services'
import {
  getTrackingId,
  setTimeOnSite,
  setTimeOutProductPage,
  validateEmailRegex,
} from '../../Utils'
import sendTrackingData from '../../Functions/sendTrackingData'
import { generateResultPage } from './ResultPage'
import { checkProductPage } from './../../Utils'

import getWinnerDegree from './getWinnerDegree.ts'

let wheelPower = 0
let wheelSpinning = false
let fireworks

const startSpin = (theWheel, mainPopupData) => {
  console.log('startSpin', mainPopupData)
  if (wheelSpinning == false) {
    // if (wheelPower == 1) {
    //   theWheel.animation.spins = 3
    // } else if (wheelPower == 2) {
    //   theWheel.animation.spins = 8
    // } else if (wheelPower == 3) {
    //   theWheel.animation.spins = 15
    // }

    // const LIST = [
    //   { title: '15% OFF 1 ', color: '#FA541C', code: '', rate: '90.00' },
    //   { title: '15% OFF 2 ', color: '#FAAD14', code: '', rate: '0.00' },
    //   { title: '15% OFF 3', color: '#FA541C', code: '', rate: '0.00' },
    //   { title: '15% OFF 4', color: '#FAAD14', code: '', rate: '0.00' },
    //   { title: '15% OFF 5', color: '#FA541C', code: '', rate: '0.00' },
    //   { title: '15% OFF 6', color: '#FAAD14', code: '', rate: '0.00' },
    //   { title: '15% OFF 7', color: '#FAAD14', code: '', rate: '0.00' },
    //   { title: '15% OFF 8', color: '#FAAD14', code: '', rate: '0.00' },
    // ]

    const winnerItemAngle = getWinnerDegree(mainPopupData?.wheel.wheels)

    // only run probability func if winner degree is found, else run random
    if (winnerItemAngle || winnerItemAngle === 0) {
      const itemAngle = 360 / mainPopupData?.wheel.wheels.length

      // will stop somewhere inside the winner item
      let stopAt = winnerItemAngle + Math.floor(Math.random() * itemAngle)

      // Important thing is to set the stopAngle of the animation before stating the spin.
      theWheel.animation.stopAngle = stopAt
    }

    theWheel.startAnimation()
    wheelSpinning = true
  }
}

const showSpinGame = () => {
  let minimizeButton = document.getElementById('kariba_spin_game_minimize')
  minimizeButton.className = 'hide-class'

  let mainContent = document.getElementById('kariba_overlay_container')
  mainContent.className = 'show-class'
}

const hideSpinGame = (node_uuid) => {
  let mainContent = document.getElementById('kariba_overlay_container')
  mainContent.className = 'hide-class'

  let minimizeButton = document.getElementById('kariba_spin_game_minimize')

  minimizeButton.className = 'show-class'
  closePopup(node_uuid, clearAll)
}

const generateDefaultPage = (mainPopupData, minimizeData, opts = {}) => {
  const backgroundUrl = mainPopupData.background?.url || ''
  const arrowUrl = mainPopupData.imgArrow?.url || ''
  const minimizeTitle = minimizeData.text?.content || ''
  const titleStyle = minimizeData.text?.style || {}

  const spinHTML = `<div id="kariba_wheel_container" class="${true ? 'mobile' : ''}">
    <div class="kariba-background-plate">
        <span class="kariba-arrow-down"></span>
        <canvas id="kariba_popup_canvas" width="310" height="310"></canvas>
    </div>
    <img src=${arrowUrl} alt="gift image" class="kariba-image-decorator" style="position:absolute;bottom:0px;right:-50px;" />
  </div>`

  const html = `
    <div id="kariba_spin_game_minimize" class="hide-class"
      style="background: url(${backgroundUrl || ''}) no-repeat;
        background-size: cover;
        background-position: center;">
        <span
        style="font-family: ${titleStyle.fontFamily || 'Inter'};
          color: ${titleStyle.color || '#FA541C'};
          font-size: ${titleStyle.fontSize || 14}px;
          font-weight: ${titleStyle.fontStyle || 'bold'};"
        >${minimizeTitle}</span>
      </div>
      <div id="kariba_overlay_container">
        <div id="kariba_spin_game" class="show-class"
          style="background: url(${backgroundUrl}) no-repeat;
          background-size: cover;
          background-position: center;"
        >
          <div id="kariba_close_spin_game"><i class="material-icons">&#xe5cd;</i></div>
          ${spinHTML}
          <div id="kariba_spin_game_input_wrapper" class="spin-game"></div>
      </div>
    </div>`

  return html
}

const handleWheelData = (submitData, mainPopupData, resultData) => {
  const wheel = mainPopupData?.wheel
  const options = wheel?.wheels || []
  const computedOptions = options.map((option) => ({
    fillStyle: option.color,
    text: option.title,
    code: option.code,
    strokeStyle: '#FFF',
  }))
  var audio = new Audio(
    'https://storage.cloud.google.com/dreamf-mcm-public-storage/assets/audio/tick.mp3'
  ) // Create audio object and load tick.mp3 file.

  function playSound() {
    // Stop and rewind the sound if it already happens to be playing.
    audio.pause()
    audio.currentTime = 0

    // Play the sound.
    audio.play()
  }

  return {
    ...DEFAULT_WHEEL_DATA,
    segments: computedOptions,
    numSegments: computedOptions.length,
    // Define spin to stop animation.
    animation: {
      type: 'spinToStop',
      duration: wheel.movement,
      spins: 8,
      callbackFinished: (indicatedSegment) =>
        callbackFinished(indicatedSegment, submitData, resultData),
      callbackSound: playSound, // Function to call when the tick sound is to be triggered.
      soundTrigger: 'pin', // Specify pins are to trigger the sound, the other option is 'segment'.
    },
  }
}

const generateWheelPageContent = (mainPopupData = {}) => {
  const giftImage = mainPopupData?.imgGift?.url || ''
  const title = mainPopupData?.text?.content || ''
  const titleStyle = mainPopupData?.text?.style || {}
  const text_1 = mainPopupData?.text_1?.content || ''
  const text_1Style = mainPopupData?.text_1?.style || {}
  const text_2 = mainPopupData?.text_2?.content || ''
  const text_2Style = mainPopupData?.text_2?.style || {}
  const inputPlaceholder = mainPopupData?.input?.content || ''
  const inputStyle = mainPopupData?.input?.style || {}
  const errorTextColor = mainPopupData?.input?.errorTextColor || ''
  const buttonText = mainPopupData?.button?.content || ''
  const buttonStyle = mainPopupData?.button?.style || {}

  const html = `
          <img src=${giftImage} alt="gift image"
            style="width: 100px; height: 100px; 
            align-self: flex-end;" class="kariba-image-decorator" />

          <span class="k-input-item" style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
                    color: ${titleStyle.color || '#FA541C'};
                    font-size: ${titleStyle.fontSize || 36}px;
                    font-weight: ${titleStyle.fontStyle || 'bold'};
                    text-align: ${titleStyle.textAlign || 'left'};">
            ${title}
          </span>
          <span class="k-input-item" style="font-family: ${text_1Style.fontFamily || 'Inter'}; 
            color: ${text_1Style.color || '#FA541C'};
            font-size: ${text_1Style.fontSize || 20}px;
            font-weight: ${text_1Style.fontStyle || 'bold'};
            text-align: ${text_1Style.textAlign || 'left'};
            ">${text_1}</span>
            
          <span class="k-input-item" style="font-family: ${text_2Style.fontFamily || 'Inter'}; 
            color: ${text_2Style.color || '#FA541C'};
            font-size: ${text_2Style.fontSize || 14}px;
            font-weight: ${text_2Style.fontStyle || 'bold'};
            text-align: ${text_2Style.textAlign || 'left'};
            ">${text_2}</span>
          <input
              class="k-input-item"
              id="kariba_minigame_email";
              placeholder='${inputPlaceholder || 'Enter email'}'
              style="font-family: ${inputStyle.fontFamily || 'Inter'}; 
                color: ${inputStyle.color || '#000'};
                font-size: ${inputStyle.fontSize || 14}px;
                font-weight: ${inputStyle.fontStyle || 'nomal'};
                text-align: ${inputStyle.textAlign || 'left'};
                padding: 9px 16px;
                height: 40px;
                border-radius: 4px;
                margin-bottom: unset;
                border: 1px solid rgba(0, 0, 0, 0.15);"
          />
          <div 
            id="kariba_alert_email" 
            style="font-family: ${'Inter'};
            color: ${`${errorTextColor || '#FA541C'}`};
            font-size: ${22}px;
            font-weight: ${'normal'};
            text-align: ${'left'};">Email bạn nhập vào không hợp lệ</div>
          <button
            id="start_spin_wheel"
            class="k-input-item"
            style="font-family: ${buttonStyle.fontFamily || 'Inter'}; 
            background-color: ${buttonStyle.backgroundColor || '#FA541C'};
            color: ${buttonStyle.color || '#FFF'};
            font-size: ${buttonStyle.fontSize || 12}px;
            font-weight: ${buttonStyle.fontStyle || 'nomal'};
            text-align: ${buttonStyle.textAlign || 'center'};
            padding: 4px 16px;
            height: 40px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            margin-top: 12px;"
          >${buttonText}</button>`

  return html
}

const clearAll = () => {
  document.getElementById('kariba_overlay_container')?.remove()
  document.getElementById('kariba_result_container_result')?.remove()
  document.getElementById('kariba_spin_game')?.remove()
  document.getElementById('kariba_spin_game_minimize')?.remove()
}

const showEffect = (effects) => {
  if (effects === 'Confetti') {
    const canvas = document.getElementById('kariba_effect_canvas')
    const myConfetti = confetti.create(canvas, { resize: true, useWorker: true })
    myConfetti({ particleCount: 100, spread: 160 })
  } else if (effects === 'Fireworks') {
    const wrapper = document.getElementById('effect_wrapper')
    wrapper.addEventListener('click', function () {
      this.remove()
    })
    fireworks = new Fireworks(wrapper)
    fireworks.start()
  }
}

const callbackFinished = (indicatedSegment, submitData, resultData) => {
  const trackingId = getTrackingId()
  const emailValue = document.getElementById('kariba_minigame_email')?.value
  const effects = resultData?.background?.effects
  const isConfetti = resultData?.background?.effects == 'Confetti'

  document.getElementById('kariba_overlay_container')?.remove()
  document.getElementById('kariba_spin_game_minimize')?.remove()
  generateResultPage(resultData, {
    text: indicatedSegment.text,
    code: indicatedSegment.code,
  })
  localStorage.setItem(`isPlayed-${submitData?.node_uuid}`, 1)

  showEffect(effects)

  //! Send Tracking data
  const trackingData = {
    email: emailValue,
    utm_s: submitData?.data?.email?.emailData?.utm_source,
    utm_m: submitData?.data?.email?.emailData?.utm_medium,
    utm_c: submitData?.data?.email?.emailData?.utm_campaign,
    coupon: indicatedSegment.code,
    node_uuid: submitData?.node_uuid,
    popup_t: 3, // 'random_gift' -> 1 | 'default_code' -> 2 | 'spin_game' -> 3
  }
  // console.log('init ~ trackingData: ', trackingData)
  sendTrackingData(POPUP_ENRICH_DATA_TRACKING_CODE, trackingData)

  //! Submit data to Kariba
  const valueSubmit = {
    tracking_id: trackingId,
    node_uuid: submitData.node_uuid,
    coupon_code: indicatedSegment.code,
    email: emailValue,
  }

  // console.log('submit data to Kariba ~ valueSubmit: ', valueSubmit)
  submitMinigame(valueSubmit)

  let continueShopping = document.getElementById('kariba_continue_shopping')
  continueShopping.addEventListener('click', function () {
    clearAll()
    if (effects === 'Fireworks') fireworks.stop()
  })
}

const handleShowPopup = (resp) => {
  // console.log('show Popup')
  const submitData = resp
  const mainPopupData = resp?.data.mainPopup
  const minimizeData = resp?.data.minimize
  const resultData = resp?.data.result

  const DEFAULT = generateDefaultPage(mainPopupData, minimizeData)

  let resultElement = document.getElementById('kariba_result_container_result')
  if (resultElement) resultElement.remove()

  let mainContent = document.getElementById('kariba_spin_game')

  if (!mainContent) document.body.innerHTML += DEFAULT
  showPopup(resp?.node_uuid)
  // mainContent = document.getElementById('kariba_spin_game')

  const showError = (errMesg) => {
    const alertEmail = document.getElementById('kariba_alert_email')
    alertEmail.style.display = 'block'
    alertEmail.textContent = errMesg || 'Email không hợp lệ'
  }

  const hideError = () => {
    const alertEmail = document.getElementById('kariba_alert_email')
    document.getElementById('kariba_alert_email').style.display = 'none'
  }

  const computedWheelData = handleWheelData(submitData, mainPopupData, resultData)
  const theWheel = new Winwheel(computedWheelData)

  const handleStartSpin = async (node_uuid) => {
    console.log('start spin wheel', mainPopupData)
    var emailValue = document.getElementById('kariba_minigame_email')
    const alertEmail = document.getElementById('kariba_alert_email')
    if (validateEmailRegex(emailValue)) {
      const resp = await validateEmail(emailValue?.value, node_uuid)
      if (resp.status === 200) {
        startSpin(theWheel, mainPopupData)
        hideError()
      } else {
        showError(resp?.msg?.detail)
        // startSpin(theWheel, mainPopupData)
      }
    } else {
      showError()
    }
  }

  const html = generateWheelPageContent(mainPopupData)

  let formContent = document.getElementById('kariba_spin_game_input_wrapper')
  formContent.innerHTML = formContent.innerHTML + html

  let spinButton = document.getElementById('start_spin_wheel')
  spinButton.addEventListener('click', () => handleStartSpin(resp?.node_uuid))

  let minimizeButton = document.getElementById('kariba_spin_game_minimize')
  minimizeButton.addEventListener('click', () => showSpinGame())

  let closeSpinGame = document.getElementById('kariba_close_spin_game')
  closeSpinGame.addEventListener('click', () => hideSpinGame(resp?.node_uuid))
}

export const generateSpinGame = (resp) => {
  // console.log('resp: ', resp)
  if (!resp) return
  if (!shouldShowPopup(resp?.node_uuid)) return

  const checkTimeOnSite = async () => {
    const { timeOnSite, products, time } = resp?.data?.mainPopup?.background
    var flag = true
    if (products > 0) {
      const isProductPage = checkProductPage(resp?.node_uuid)
      if (isProductPage) {
        const isOke = await setTimeOutProductPage(time, products, resp?.node_uuid)
        if (!isOke) {
          flag = false
        } else {
          setTimeout(() => {
            handleShowPopup(resp)
            const count = parseInt(localStorage.getItem(`minigame-${resp?.node_uuid}`))
            sessionStorage.setItem(`minigameInSession-${resp?.node_uuid}`, 1)
            localStorage.setItem(`minigame-${resp?.node_uuid}`, !count ? 1 : count + 1)
            localStorage.setItem('TimeReceivedPopup', Date.now())
          }, 5000)

          // console.log('Product > 0')
          return
        }
      }
    }

    if (timeOnSite > 0) {
      const isOke = await setTimeOnSite(timeOnSite, resp?.node_uuid)
      console.log('isOke: ', isOke)
      if (!isOke) {
        flag = false
      } else {
        handleShowPopup(resp)
        sessionStorage.setItem(`minigameInSession-${resp?.node_uuid}`, 1)
        const count = parseInt(localStorage.getItem(`minigame-${resp?.node_uuid}`))
        localStorage.setItem(`minigame-${resp?.node_uuid}`, !count ? 1 : count + 1)
        // console.log('timeOnSite > 0')
        return
      }
    }
    if (!flag) return
  }
  checkTimeOnSite()
}
